var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInputSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.777649 6.06665C0.777649 3.14565 3.14556 0.77771 6.06653 0.77771C8.98749 0.77771 11.3554 3.14565 11.3554 6.06665C11.3554 8.98765 8.98749 11.3556 6.06653 11.3556C3.14556 11.3556 0.777649 8.98765 0.777649 6.06665ZM6.06653 2.02217C3.83285 2.02217 2.02209 3.83294 2.02209 6.06665C2.02209 8.30036 3.83285 10.1111 6.06653 10.1111C8.30021 10.1111 10.111 8.30036 10.111 6.06665C10.111 3.83294 8.30021 2.02217 6.06653 2.02217Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92435 8.92436C9.16734 8.68136 9.56131 8.68136 9.8043 8.92436L13.0399 12.1599C13.2828 12.4029 13.2828 12.7969 13.0399 13.0399C12.7969 13.2829 12.4029 13.2829 12.1599 13.0399L8.92435 9.80432C8.68136 9.56133 8.68136 9.16735 8.92435 8.92436Z",
    fill: "#757575"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputSearch);
export default __webpack_public_path__ + "static/media/input-search.a7001a3a84c53b66f8884295dd7138b8.svg";
export { ForwardRef as ReactComponent };